export default import.meta.ROLLUP_FILE_URL_FywqUzfb7DFuNU0M9u4J1g